/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class MoveOrderService {
  private url: string = environment.host + '/participant/';
  private futurePeriodUrl: string = environment.host + '/period/follows/1';
  private previousPeriodUrl: string = environment.host + '/period/priorPeriod/1';
  private transactionUrl: string = environment.host + '/transaction';
  private currentPeriodUrl: string = environment.host + '/currentperiod';

  constructor(private http: HttpClient) {}

  // getOrderByNumber(orderNo, clientId){
  //     let url = environment.host + '/transaction/'+ clientId+ '/' + orderNo;
  //     return this.http.get(url).toPromise();
  // }

  public getCurrentOrders(curPeriod: any, clientId: any) {
    return this.http.get(this.transactionUrl.toString() + '/' + clientId + '/' + curPeriod).toPromise();
  }

  public getPreviousPeriods(args?: any) {
    if (args && args.hideLoader) {
      // const headers = new Headers();
      // headers.append('hideLoader', 'true');
      // const options = new RequestOptions({ headers: headers });
      return this.http.get(this.futurePeriodUrl.toString(), { observe: 'body' }).toPromise();
      // const httpHeaders = new HttpHeaders()
      //              .set('hideLoader', 'true');
      // return this.http.get(this.periodUrl.toString(), {
      //     observe: 'body',
      //     headers: httpHeaders
      // }).toPromise();
    } else {
      return this.http.get(this.futurePeriodUrl.toString()).toPromise();
    }
  }

  public getPeriods(args?: any) {
    const url = args && args.fromReprocess ? this.previousPeriodUrl.toString() : this.futurePeriodUrl.toString();
    if (args && args.hideLoader) {
      // const headers = new Headers();
      // headers.append('hideLoader', 'true');
      // const options = new RequestOptions({ headers: headers });
      return this.http.get(url, { observe: 'body' }).toPromise();
      // const httpHeaders = new HttpHeaders()
      //              .set('hideLoader', 'true');
      // return this.http.get(this.periodUrl.toString(), {
      //     observe: 'body',
      //     headers: httpHeaders
      // }).toPromise();
    } else {
      return this.http.get(url).toPromise();
    }
  }

  public getCurrentPeriod(regionCode: string) {
    if (regionCode) {
      return this.http.get(this.currentPeriodUrl + '?regionCode=' + regionCode).toPromise();
    } else {
      return this.http.get(this.currentPeriodUrl).toPromise();
    }
  }

  public getPeriodDtls(period: any, clientId: any) {
    const url = environment.host + '/participant/' + clientId + '/commission/' + period;
    return this.http.get(url).toPromise();
  }

  public moveOrder(payload: any) {
    return this.http.post(this.transactionUrl.toString(), payload).toPromise();
  }

  public getCommissionVolumes(clientId: any, period: any, isRealTime: any) {
    const url = environment.host + '/participant/' + clientId + '/planPeriod/' + period + '?isRealtime=' + isRealTime;
    return this.http.get(url).toPromise();
  }
}
